"use strict";
exports.__esModule = true;
exports.RoomService = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var model_1 = require("./model");
var store_1 = require("./store");
var room_helper_service_1 = require("./room-helper.service");
var getRoom = function (sessionId, roomId) {
    store_1.RoomStore.setLoading(true);
    return room_helper_service_1.RoomHelperService.fetchRoom(sessionId, roomId).pipe(operators_1.first(), operators_1.map(function (roomDescription) {
        return roomDescription;
    }), operators_1.catchError(function (err) {
        store_1.RoomStore.setLoading(false);
        console.log(err);
        return rxjs_1.of([]);
    }));
};
var getRooms = function (sessionId) {
    store_1.RoomStore.setLoading(true);
    return room_helper_service_1.RoomHelperService.fetchRooms(sessionId).pipe(operators_1.first(), operators_1.map(function (_a) {
        var roomsDescriptions = _a[0], roomsSearch = _a[1];
        var rooms = roomsDescriptions.map(function (rd) {
            var rs = roomsSearch.rooms.find(function (r) { return r.roomId === rd.roomId; }) || {};
            return model_1.createRoom(rd, rs);
        });
        store_1.RoomStore.set(rooms);
        store_1.RoomStore.setLoading(false);
        return rooms;
    }), operators_1.catchError(function (err) {
        store_1.RoomStore.setLoading(false);
        console.log(err);
        return rxjs_1.of([]);
    }));
};
var getRoomPricesForStayPeriods = function (stayPeriods, currency) {
    var observables = stayPeriods.map(function (sp) { return room_helper_service_1.RoomHelperService.getRoomsSearchForSpecificStayPeriod(sp, currency); });
    return rxjs_1.zip.apply(void 0, observables).pipe(operators_1.map(function (prices) {
        return room_helper_service_1.RoomHelperService.formatPricesForStayPeriods(stayPeriods, prices);
    }));
};
var getRoomsAvailability = function (sessionId, options) {
    return room_helper_service_1.RoomHelperService.getRoomsSearch(sessionId, options)
        .pipe(operators_1.map(function (res) { return res.unavailabilityType; }));
};
var resetCacheFetchRooms = function () { return room_helper_service_1.RoomHelperService.resetCacheFetchRooms(); };
exports.RoomService = { getRoom: getRoom, getRooms: getRooms, getRoomPricesForStayPeriods: getRoomPricesForStayPeriods, resetCacheFetchRooms: resetCacheFetchRooms, getRoomsAvailability: getRoomsAvailability };
//# sourceMappingURL=room.service.js.map